import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16aeee6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nv-slider" }
const _hoisted_2 = {
  class: "nv-slider-container",
  ref: "sliderContainerRef"
}
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slidesCount, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "nv-slider-slide",
          key: i,
          id: `nv-slider-${_ctx.sliderId}-slide-${i}`,
          style: _normalizeStyle({ minWidth: `${100 / _ctx.slidesToShow}%` })
        }, [
          _renderSlot(_ctx.$slots, `slide-${i}`, {}, undefined, true)
        ], 12, _hoisted_3))
      }), 128))
    ], 512)
  ]))
}